import { ImageConfigTypes, JSONDataTypes, JSONShortInfoTypes } from '../../types';
import { LayoutItemTypes, ShortInfoEntryTypes } from '../../types/response';

const JSON_INFO_TYPES = {
  INTRO: 'INTRO',
  INFORMATION: 'INFORMATION',
};

export const convertLayoutItem = (item: LayoutItemTypes): ImageConfigTypes => {
  return {
    icon: item.icon,
    labelColor: item.labelColor,
    labelCoords: item.labelCoords,
    zoneColor: item.zoneColor,
    zoneCoords: item.zoneCoords,
    labelTransparent: item.labelTransparent,
    transparent: item.transparent,
  };
};

export const convertShortInfoEntry = (shortInfo: ShortInfoEntryTypes[]): JSONShortInfoTypes => {
  const introduction: JSONDataTypes[] = [];
  const information: JSONDataTypes[] = [];
  const shortInformation: JSONDataTypes[] = [];

  if (!shortInfo || !shortInfo.length) {
    return {
      introduction,
      shortInformation,
      information,
    };
  }

  shortInfo.forEach((i: { title: string; description: string }) => {
    const { title, description } = i;
    const jsonData = {
      key: title,
      value: description,
    };
    if (title.toUpperCase() === JSON_INFO_TYPES.INTRO) {
      introduction.push(jsonData);
      return;
    }

    if (title.toUpperCase() === JSON_INFO_TYPES.INFORMATION) {
      information.push(jsonData);
      return;
    }

    shortInformation.push(jsonData);
  });

  return {
    introduction,
    shortInformation,
    information,
  };
};
